import { type ProfileChangeLog } from "@clipboard-health/contract-backend-main";
import { Alert, Button, Spin } from "antd";

import { ProfileChangeLogsTable } from "./ProfileChangeLogsTable";
import { Box } from "@mui/material";

interface ProfileChangeLogsModalContentProps {
  isError: boolean;
  isLoading: boolean;
  isFetchingNextPage: boolean;
  hasNextPage: boolean;
  logs: ProfileChangeLog[];
  onLoadMore: () => void;
}

export function ProfileChangeLogsModalContent(props: ProfileChangeLogsModalContentProps) {
  const { isError, isLoading, isFetchingNextPage, hasNextPage, logs, onLoadMore } = props;

  if (isError) {
    return (
      <Alert
        message="There was an error loading profile change logs. Please try again later."
        type="error"
      />
    );
  }

  if (isLoading) {
    return (
      <Box sx={{ textAlign: "center", padding: 3 }}>
        <Spin />
      </Box>
    );
  }

  return (
    <>
      <ProfileChangeLogsTable logs={logs} />
      {hasNextPage && (
        <Box sx={{ textAlign: "center", marginTop: 1.5, height: 32, lineHeight: "32px" }}>
          <Button loading={isFetchingNextPage} onClick={onLoadMore}>
            Load more
          </Button>
        </Box>
      )}
    </>
  );
}
